import { render, staticRenderFns } from "./CustomerStock.vue?vue&type=template&id=f5ff3398&"
import script from "./CustomerStock.vue?vue&type=script&lang=js&"
export * from "./CustomerStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports